<template>
  <div
    v-if="dimensionOptions.Heights || dimensionOptions.Widths"
    class="product-filters__dimensions"
  >
    <div class="product-filters__selects" :class="showCustomInputs ? 'is--disabled' : ''">
      <div v-if="dimensionOptions.Widths" class="product-filters__select-wrapper select">
        <label for="productFilterWidth" class="label">Bredd</label>
        <select
          id="productFilterWidth"
          class="product-filters__select select__select"
          v-model="selectedWidth"
        >
          <option value="0" disabled>Välj...</option>
          <option
            v-for="option in dimensionOptions.Widths"
            v-bind:key="option.Value"
            :value="option.Value"
          >
            {{ option.Value }}
          </option>
        </select>
      </div>
      <div v-if="dimensionOptions.Heights" class="product-filters__select-wrapper select">
        <label for="productFilterHeight" class="label">Höjd</label>
        <select
          id="productFilterHeight"
          class="product-filters__select select__select"
          v-model="selectedHeight"
        >
          <option value="0" disabled>Välj...</option>
          <option
            v-for="option in dimensionOptions.Heights"
            :value="option.Value"
            v-bind:key="option.Value"
          >
            {{ option.Value }}
          </option>
        </select>
      </div>
    </div>
    <div v-show="showCustomInputs" class="product-filters__inputs">
      <span class="product-filters__inputs__icon">
        <slot name="custom-input-droplet-icon">
        </slot>
      </span>
      <div v-if="dimensionOptions.Widths" class="product-filters__input">
        <label for="productFilterCustomWidth" class="label">Bredd (mm)</label>
        <input
          type="number"
          class="product-filters__input__input input"
          placeholder="Ange bredd..."
          id="productFilterCustomWidth"
          v-model="customWidth"
        />
      </div>
      <div v-if="dimensionOptions.Heights" class="product-filters__input">
        <label for="productFilterCustomHeight" class="label">Höjd (mm)</label>
        <input
          type="number"
          class="product-filters__input__input input"
          placeholder="Ange höjd..."
          id="productFilterCustomHeight"
          v-model="customHeight"
        />
      </div>
    </div>

    <button
      class="product-filters__dimensions-toggle"
      v-on:click="customInputToggle"
      :class="showCustomInputs ? 'is--active' : ''"
    >
      <span class="product-filters__dimensions-toggle__icon"></span>
      <span class="product-filters__dimensions-toggle__text">
          {{ showCustomInputs ? 'Ta bort eget mått' : 'Ange eget mått' }}
      </span>
    </button>
    <button
      class="product-filters__measure-toggle"
      v-on:click="measureToggle"
    >
      <span class="product-filters__measure-toggle__icon"></span>
      <span class="product-filters__measure-toggle__text">
        Så mäter du
      </span>
    </button>
    <div v-show="showMeasureInfo" class="product-filters__measure">
      <span class="product-filters__measure__icon">
        <slot name="measure-droplet-icon"></slot>
      </span>
      <span class="product-filters__measure__image">
        <slot name="measure-installation-icon">
        </slot>
      </span>
      <div class="rich-text">
        <p>Mät bredd (A) och höjd (B) i befintlig portöppning. Mät sidoutrymme (C), installationsdjup (D) och överhöjd (E) för att garantera tillräckligt utrymme. Se teknisk specifikation nedan för denna ports måttkrav.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from 'vue-property-decorator'

//
@Component({
  data () {
    return {
      customHeight: null,
      customWidth: null,
      selectedHeight: 0,
      selectedWidth: 0,
      showMeasureInfo: false,
      showCustomInputs: false,
      selectedSafetyClassifications: []
    }
  },
  computed: {
    dimensionOptions: function() {
      let dimensions = this.sizeOptions
      // console.log(dimensions)
      if (dimensions != '' && dimensions != null && dimensions != 'undefined') {
        const dimensionsStringify = JSON.stringify(dimensions)
        return JSON.parse(dimensionsStringify)
      } else {
        return { heights: null, widths: null}
      }
    }
  },
})
export default class Dimensions extends Vue {
  @Prop() sizeOptions;
  @Prop() onUpdated;
  @Prop() option;

  created() {
    // console.log('Dimensions created');
  }

  updated () {
    const dimensions = {
      height: this.customHeight != null && this.showCustomInputs ? parseInt(this.customHeight) : parseInt(this.selectedHeight),
      width: this.customWidth != null && this.showCustomInputs ? parseInt(this.customWidth) : parseInt(this.selectedWidth)
    }
    bus.$emit('updateProductDimensions', dimensions)
  }

  mounted () {
    this.selectedHeight = this.setSelect('Heights')
    this.selectedWidth = this.setSelect('Widths')
  }

  customInputToggle () {
    this.showCustomInputs = !this.showCustomInputs
    this.showMeasureInfo = false
  }

  measureToggle () {
    this.showMeasureInfo = !this.showMeasureInfo
    this.showCustomInputs = false
  }

  setSelect (type) {
    if (this.dimensionOptions != null) {
      if (this.dimensionOptions[type]) {
        const selectedOption = this.dimensionOptions[type].find(item => item.Selected)
        if (!selectedOption) { return 0 }
        return selectedOption.Value.toString()
      } else {
        return 0
      }
    } else {
      return null
    }
  }
}
</script>

<style>

</style>
